import { startExternalAuthFlow } from '@account/account-portal/external-auth'
import { getRuntimeInfo } from '@account/account-portal/lib'
import { GlButton } from '@adl/component-button'
import { useDevice } from '@crystal/core'
import { useTranslations } from '@crystal/translator'

import { useViewData } from '../lib'

export const KmcButton = () => {
  const { isMobile } = useDevice()
  const t = useTranslations()
  const { pageContext } = getRuntimeInfo()
  const { viewData } = useViewData()

  const onSubmit = () => {
    startExternalAuthFlow({
      method: 'kmc',
      provider: 'kmc',
      authContext: {
        redirectRoute: pageContext?.originRoute,
      },
      transitData: {
        email: viewData.email,
      },
    })
  }

  return (
    <div>
      <div className="gl-vspace-bpall-small">{t('or.separator')}</div>
      <div className="gl-vspace-bpall-small">{t('kmc.carrierAuthentication.title')}</div>
      <GlButton
        variant="secondary"
        onClick={onSubmit}
        fullWidth={isMobile}
        data-auto-id="registration-submit-button"
        className="gl-vspace-bpall-small">
        {t('kmc.carrierAuthentication.cta')}
      </GlButton>
    </div>
  )
}
